// Collapses long product descriptions with a "Read more / Read less" toggle.
// Does not touch scroll position or trigger layout thrash outside the block itself.
(function () {
  function initDescriptionToggles() {
    document.querySelectorAll('[data-description-content]').forEach(function (content) {
      if (content.dataset.toggleInit) return;
      content.dataset.toggleInit = 'true';

      var wrapper = content.closest('.product__description-block');
      if (!wrapper) return;
      var toggle = wrapper.querySelector('[data-description-toggle]');
      if (!toggle) return;

      var collapsedHeight = 132; // roughly 4-5 lines of body copy

      requestAnimationFrame(function () {
        var fullHeight = content.scrollHeight;
        if (fullHeight <= collapsedHeight + 24) return; // short description, no toggle needed

        content.style.maxHeight = collapsedHeight + 'px';
        content.classList.add('is-collapsed');
        toggle.hidden = false;

        var labelMore = toggle.querySelector('[data-label-more]');
        var labelLess = toggle.querySelector('[data-label-less]');

        toggle.addEventListener('click', function () {
          var collapsed = content.classList.toggle('is-collapsed');
          content.style.maxHeight = collapsed ? collapsedHeight + 'px' : content.scrollHeight + 'px';
          if (labelMore) labelMore.hidden = !collapsed;
          if (labelLess) labelLess.hidden = collapsed;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionToggles);
  } else {
    initDescriptionToggles();
  }
})();
